import { useEffect } from 'react';

export const useScrollToTop = () => {
  useEffect(() => {
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    };
  });
};
